import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { ArrowShortSVG } from '@common_components/svg/arrowShort.svg';

const ArrowShortIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <ArrowShortSVG/>
    </div>
  );
};

export { ArrowShortIcon };
